/**
 * Program: decoding XSS
 * Author: SKP
 */
import { StringUtil }   from '@/utils';
export default str => StringUtil.decodeXSS(str);


// WEBPACK FOOTER //
// ./src/filters/decodeXSS.js